import { useDisplayClearBtn } from 'hooks/useDisplayClearBtn'
import { endpoints } from 'modules/endpoints'
import { TableFiltersProps } from 'modules/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { AClearFiltersButton, ASearch } from 'views/components/Analytics'
import {
  FiltersAndSearchWrapper,
  FiltersWrapper,
  SearchWrapper,
} from 'views/components/CommonTableComponents/CommonTableComponents'
import { ABaseTableFilter } from 'views/components/TableFilters/ABaseTableFilter'
import { defaultListRequestParams } from 'views/components/TableFilters/data'
import { ADateRangePicker } from 'views/components/TableFilters/DateRangePicker/ADateRangePicker'

export const Filters: FC<TableFiltersProps> = ({ setListRequestParams, listRequestParams, updateFilterState }) => {
  const { t } = useTranslation('calls')

  const displayClearBtn = useDisplayClearBtn({
    listRequestParams,
  })

  return (
    <FiltersAndSearchWrapper>
      <FiltersWrapper>
        <ADateRangePicker
          onChange={(value) => updateFilterState({ date_sent_after: value.startDate, date_sent_before: value.endDate })}
          value={[listRequestParams.filter.date_sent_after, listRequestParams.filter.date_sent_before]}
          id="dateFilter"
        />
        <ABaseTableFilter
          onChange={(coordinator) => updateFilterState({ coordinator })}
          value={listRequestParams.filter.coordinator}
          id="coordinatorNameFilter"
          endpoint={endpoints.whatsAppTwilio()}
          placeholder={t('coordinator')}
          searchField="search"
        />
        {displayClearBtn && (
          <AClearFiltersButton
            onClick={() => setListRequestParams && setListRequestParams({ ...defaultListRequestParams })}
          />
        )}
      </FiltersWrapper>
      <SearchWrapper>
        <ASearch onChange={(search) => updateFilterState({ search })} value={listRequestParams?.filter?.search} />
      </SearchWrapper>
    </FiltersAndSearchWrapper>
  )
}
